export default __webpack_public_path__ + "static/media/footer.e34b5c8f.jpg";